module.exports = __webpack_public_path__ + "img/register-title.90523eaa.png";